export const buttonStyle = {
  backgroundColor: '#EDDF65',
  width: '100%'
}
